import React from 'react';
import ReactDOMServer from 'react-dom/server';

export default ({ id, placement, trigger, children }) => {
  return (
    <i
      id={id}
      className='fa-regular fa-circle-question popover-icon'
      data-popover
      data-content-ref
      data-placement={placement}
      data-trigger={trigger}
    >
      <script type='text/template'>
        {ReactDOMServer.renderToString(children)}
      </script>
    </i>
  );
};
